"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const GraphQLApiProvider_1 = require("./api-provider/resolver/GraphQLApiProvider");
const HTTPApiProvider_1 = require("./api-provider/resolver/HTTPApiProvider");
class Service {
    constructor(variables) {
        this.API = {
            headers: {},
            urls: {},
        };
        if (variables === null || variables === void 0 ? void 0 : variables.req) {
            this.req = variables.req;
        }
    }
    getApiUrl(API) {
        if (API === 'all') {
            return this.API.urls;
        }
        const apiUrl = this.API.urls[API];
        if (!apiUrl) {
            console.log(`url: ${API} not found. Did you set it with setApiUrls function inside base service?`);
            return null;
        }
        return apiUrl;
    }
    /**
     * Get default headers for API
     */
    getApiHeaders(API) {
        const header = this.API.headers[API];
        if (!header) {
            console.log(`url: ${API} not found. Did you set it with setApiHeader function inside base service?`);
        }
        return header || {};
    }
    /**
     * Create GraphQL | HTTP client for requests
     */
    createProvider(client) {
        const urls = this.getApiUrl('all');
        switch (client) {
            case 'GraphQL': {
                return new GraphQLApiProvider_1.GraphQLApiProvider({ apiUrls: urls });
            }
            case 'HTTP': {
                return new HTTPApiProvider_1.HTTPApiProvider({ apiUrls: urls });
            }
        }
    }
    /**
     * Set default urls for API
     */
    setApiUrls(urls) {
        this.API.urls = urls;
    }
    /**
     * Set default headers for API
     */
    setApiHeaders(headers) {
        this.API.headers = headers;
    }
}
exports.default = Service;
//# sourceMappingURL=Service.js.map